import './Concluido.css';
import { useNavigate } from 'react-router-dom'
import { useState } from 'react';
import BannerHomePhone from '../../Banners/BannerHomePhone/BannerHomePhone.js'
import { Radio, RadioGroup, Stack } from '@chakra-ui/react'
import FaceImg1 from '../../../imgs/face_1.svg'
import FaceImgActive1 from '../../../imgs/face_1_active.svg'
import FaceImg2 from '../../../imgs/face_2.svg'
import FaceImgActive2 from '../../../imgs/face_2_active.svg'
import FaceImg3 from '../../../imgs/face_3.svg'
import FaceImgActive3 from '../../../imgs/face_3_active.svg'
import FaceImg4 from '../../../imgs/face_4.svg'
import FaceImgActive4 from '../../../imgs/face_4_active.svg'
import FaceImg5 from '../../../imgs/face_5.svg'
import FaceImgActive5 from '../../../imgs/face_5_active.svg'
import Button from '../../../components/Button/button.js';
import api from '../../../services/api.js';

function Concluido() {
    const [isShow, setShow] = useState(false);
    const navigate = useNavigate();
    const [value, setValue] = useState()
    const [payload, setPayload] = useState([]);
    const handleChangeInputs = (value, prop) => {
        setPayload({ ...payload, [prop]: value })
    }

    const data_encode = sessionStorage.getItem("encode_data")
    const [mensagem, setMensagem] = useState('');
    const [nota, setNota] = useState('');

    payload.radio = value;

    async function handleSubmit(e) {
        e.preventDefault();
        setShow(true);

        api.post("/crefaz/feedback/",{ 
                "encode_data": data_encode,
                "nota": nota, 
                "comentario": mensagem
        },{

        })
        .then((response) => {
            console.log(response.data)
            navigate("/obrigado");
            setShow(false);
        })
        .catch((err) => {
            console.log("Erro", err)
            setShow(false);
        })
    }

    const handleClick = (value) => {
        setNota(value);

        if (value === "1") {
            var element = document.getElementById("img1")
            element.classList.add("inactive")
            element = document.getElementById("img1active")
            element.classList.remove("inactive")
            element = document.getElementById("img2")
            element.classList.remove("inactive")
            element = document.getElementById("img3")
            element.classList.remove("inactive")
            element = document.getElementById("img4")
            element.classList.remove("inactive")
            element = document.getElementById("img5")
            element.classList.remove("inactive")
            element = document.getElementById("img2active")
            element.classList.add("inactive")
            element = document.getElementById("img3active")
            element.classList.add("inactive")
            element = document.getElementById("img4active")
            element.classList.add("inactive")
            element = document.getElementById("img5active")
            element.classList.add("inactive")
        }
        if (value === "2") {
            element = document.getElementById("img2")
            element.classList.add("inactive")
            element = document.getElementById("img2active")
            element.classList.remove("inactive")
            element = document.getElementById("img1")
            element.classList.remove("inactive")
            element = document.getElementById("img3")
            element.classList.remove("inactive")
            element = document.getElementById("img4")
            element.classList.remove("inactive")
            element = document.getElementById("img5")
            element.classList.remove("inactive")
            element = document.getElementById("img1active")
            element.classList.add("inactive")
            element = document.getElementById("img3active")
            element.classList.add("inactive")
            element = document.getElementById("img4active")
            element.classList.add("inactive")
            element = document.getElementById("img5active")
            element.classList.add("inactive")
        }
        if (value === "3") {
            element = document.getElementById("img3")
            element.classList.add("inactive")
            element = document.getElementById("img3active")
            element.classList.remove("inactive")
            element = document.getElementById("img1")
            element.classList.remove("inactive")
            element = document.getElementById("img2")
            element.classList.remove("inactive")
            element = document.getElementById("img4")
            element.classList.remove("inactive")
            element = document.getElementById("img5")
            element.classList.remove("inactive")
            element = document.getElementById("img1active")
            element.classList.add("inactive")
            element = document.getElementById("img2active")
            element.classList.add("inactive")
            element = document.getElementById("img4active")
            element.classList.add("inactive")
            element = document.getElementById("img5active")
            element.classList.add("inactive")
        }
        if (value === "4") {
            element = document.getElementById("img4")
            element.classList.add("inactive")
            element = document.getElementById("img4active")
            element.classList.remove("inactive")
            element = document.getElementById("img1")
            element.classList.remove("inactive")
            element = document.getElementById("img2")
            element.classList.remove("inactive")
            element = document.getElementById("img3")
            element.classList.remove("inactive")
            element = document.getElementById("img5")
            element.classList.remove("inactive")
            element = document.getElementById("img1active")
            element.classList.add("inactive")
            element = document.getElementById("img2active")
            element.classList.add("inactive")
            element = document.getElementById("img3active")
            element.classList.add("inactive")
            element = document.getElementById("img5active")
            element.classList.add("inactive")
        }
        if (value === "5") {
            element = document.getElementById("img5")
            element.classList.add("inactive")
            element = document.getElementById("img5active")
            element.classList.remove("inactive")
            element = document.getElementById("img1")
            element.classList.remove("inactive")
            element = document.getElementById("img2")
            element.classList.remove("inactive")
            element = document.getElementById("img3")
            element.classList.remove("inactive")
            element = document.getElementById("img4")
            element.classList.remove("inactive")
            element = document.getElementById("img1active")
            element.classList.add("inactive")
            element = document.getElementById("img2active")
            element.classList.add("inactive")
            element = document.getElementById("img3active")
            element.classList.add("inactive")
            element = document.getElementById("img4active")
            element.classList.add("inactive")
        }
    }

    return (
        <div className="home">
            <div className='backgroundLateral2'></div>
            <div className='informacoesAguarde4'>
                <div className='informacoes_recebidas'>Processo Concluído!</div>
                <h3 className='informacoesH3a'>Sua opinião é muito importante para nós</h3>
                <p className='pInformacoesa'>O quão satisfeito você ficou com o nosso atendimento?</p>
                <div className='cb'></div>
                
                <form className="" onSubmit={handleSubmit}>
                    <div className='svgfeedbackbl'>
                        <div className='svgfeedback2'>
                            <div className='svg-row'>
                                <RadioGroup
                                    name="radio"
                                    onChange={setValue || ((e) => handleChangeInputs(e.target.value, "radio"))}
                                    onClick={((e) => handleClick(e.target.value, "radio"))}
                                    className='radio-buttons'
                                    value={value}
                                >
                                    <Stack
                                        className="radio-group"
                                        spacing={10}
                                        direction='row'
                                        id="myRadio"
                                        name="myRadio"
                                    >
                                        <label className='label-feedback'>
                                            <Radio name="nota" className='radio-button-face' value="1" ></Radio>
                                            <img className='dropdown' alt='#' src={FaceImg1} id="img1" />
                                            <img className='inactive' alt='#' src={FaceImgActive1} id="img1active" />
                                        </label>
                                        <label className='label-feedback'>
                                            <Radio name="nota" className='radio-button-face' value="2"></Radio>
                                            <img className='dropdown' alt='#' src={FaceImg2} id="img2" />
                                            <img className='inactive' alt='#' src={FaceImgActive2} id="img2active" />
                                        </label>
                                        <label className='label-feedback'>
                                            <Radio name="nota" className='radio-button-face' value="3"></Radio>
                                            <img className='dropdown' alt='#' src={FaceImg3} id="img3" />
                                            <img className='inactive' alt='#' src={FaceImgActive3} id="img3active" />
                                        </label>
                                        <label className='label-feedback'>
                                            <Radio name="nota" className='radio-button-face' value="4"></Radio>
                                            <img className='dropdown' alt='#' src={FaceImg4} id="img4" />
                                            <img className='inactive' alt='#' src={FaceImgActive4} id="img4active" />
                                        </label>
                                        <label className='label-feedback'>
                                            <Radio name="nota" className='radio-button-face' value="5"></Radio>
                                            <img className='dropdown' alt='#' src={FaceImg5} id="img5" />
                                            <img className='inactive' alt='#' src={FaceImgActive5} id="img5active" />
                                        </label>
                                    </Stack>
                                </RadioGroup>
                            </div>
                        </div>
                    </div>

                    <div className='conte_experiencia'>
                        <div className='label ce'><b>Conte sua experiência</b> (opcional)</div>
                        <textarea 
                            name='mensagem'
                            value={mensagem}
                            className='feeedback-text'
                            rows="7"
                            cols="70"
                            placeholder='Escreva sua mensagem...'
                            onChange={(event) =>
                                setMensagem(event.target.value)
                            }>    
                        </textarea>
                    

                    <Button
                        message="ENVIAR OPINIÃO"
                        className='btnContinuar3'
                        isChecked="true"
                        type="submit"
                    />

                        <div
                          
                            className="btnVoltar"
                            cursor='pointer'
                            onClick={() => navigate("/obrigado")}>CONTINUAR APENAS</div>

                            
</div>

                </form >

                <div className='conte_experiencia'>
                    <div className='label2'>
                        <div className='tita'>Muito obrigado por escolher a Eu Quero Grana.</div>
                        <div className='titb'>E conte sempre com o seu amigo financeiro!</div>
                    </div>
                    <div className='falecon'>
                        Central de relacionamento<br />
                        <b>falecom@euquerograna.com.br<br />0800 1000 123</b>
                    </div>   
                </div>
            </div>
            <div className='backgroundLateral2'></div>
        </div>
    );
}

export default Concluido;